import BaseComponent from "../../../baseComponent.js";
import Tabs from "./tabs.jsx";
import Overview from "./overview/overview.jsx";
import DataProfile from "./dataprofile/dataprofile.jsx";
import License from "./license/license.jsx";
import Data from "./data/data.jsx";
import styles from "./content.scss";


export default class Content extends BaseComponent {
  constructor(props) {
    super(props);
    this.tabs = [
      {
        title: "Overview",
        component: Overview,
        props: {
          dataset: this.props.dataset
        }
      },
      {
        title: "Data Profile",
        component: DataProfile,
        props: {
          dataset: this.props.dataset
        }
      },
      {
        title: "License",
        component: License,
        props: {
          dataset: this.props.dataset,
          subscriptions: this.props.subscriptions,
          response: this.response
        }
      },
      {
        title: "Data",
        component: Data,
        props: {
          dataset: this.props.dataset,
          subscription: this.props.subscription
        }
      }
    ];

    if (isMobile()) {
      this.tabs.pop();
    }
  }


  response(value){
    this.props.response(value);
  }
  
  render() {

    return (
      <div className={styles.container}>
        <Tabs tabs={this.tabs} control={this.props.control}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/content/content.jsx